import React from 'react'

import { Helmet } from 'react-helmet'

import Header from '../../components/header'
import Footer from '../../components/footer'
import Whatsapp from '../../components/whatsapp'
import './direito-de-famlia.css'

const DireitoDeFamlia = (props) => {
  return (
    <div className="direito-de-famlia-container10">
      <Helmet>
        <title>Direito-de-Famlia - Adv. Wanderson H Cavalari - Cuiabá</title>
        <meta
          name="description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
        <meta
          property="og:title"
          content="Direito-de-Famlia - Adv. Wanderson H Cavalari - Cuiabá"
        />
        <meta
          property="og:description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
      </Helmet>
      <div className="direito-de-famlia-container11">
        <main className="direito-de-famlia-container12">
          <div className="direito-de-famlia-container13">
            <Header rootClassName="headerroot-class-name17"></Header>
            <div className="direito-de-famlia-container14">
              <div className="direito-de-famlia-frame46">
                <span className="direito-de-famlia-text10">
                  ÁREA DE ATUAÇÃO
                </span>
                <span className="direito-de-famlia-text11">Direito de</span>
                <span className="direito-de-famlia-text12">Família</span>
                <span className="direito-de-famlia-text13">
                  A advocacia de família abrange questões legais relacionadas a
                  casamento, divórcio, guarda de filhos, pensão alimentícia,
                  partilha de bens e adoção.
                </span>
              </div>
              <div className="direito-de-famlia-container15">
                <span className="direito-de-famlia-text14">
                  <span>Fale Comigo</span>
                </span>
                <span className="direito-de-famlia-text16 Content">
                  Quer saber mais sobre esta área de atuação? Mande-me uma
                  mensagem para introduzirmos esta questão
                </span>
                <iframe
                  src="https://whc-dun.vercel.app/email"
                  scrolling="no"
                  className="direito-de-famlia-iframe"
                ></iframe>
              </div>
            </div>
          </div>
          <div className="direito-de-famlia-container16">
            <div className="direito-de-famlia-container17">
              <div className="direito-de-famlia-frame86">
                <div className="direito-de-famlia-container18">
                  <div className="direito-de-famlia-container19">
                    <span className="direito-de-famlia-text17">
                      Ações de Separação de Corpos
                    </span>
                    <span className="direito-de-famlia-text18">
                      Em certos casos, a intervenção judicial se torna
                      necessária para efetuar a separação entre os cônjuges,
                      geralmente com o objetivo de garantir a proteção da
                      integridade física e mental das partes envolvidas.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <div className="direito-de-famlia-container20">
                      <span className="direito-de-famlia-text19">
                        <span>Ações de Separação Judicial</span>
                        <br></br>
                      </span>
                      <span className="direito-de-famlia-text22">
                        Desde a promulgação da Emenda Constitucional nº 66, não
                        se reconhecem mais ações de separação judicial no
                        ordenamento jurídico brasileiro. A partir dessa
                        alteração legislativa, quando as partes optam pela
                        dissolução do vínculo matrimonial, têm duas opções para
                        regularizar sua situação: por meio do divórcio ou
                        através da separação de corpos.
                      </span>
                    </div>
                  </div>
                  <img
                    alt="image"
                    src="/unia%C3%AC%C2%83o%20esta%C3%AC%C2%81vel%20separation-300h.webp"
                    loading="eager"
                    className="direito-de-famlia-image1 section_image"
                  />
                </div>
                <div className="direito-de-famlia-container21">
                  <img
                    alt="image"
                    src="/photo%20from%20unsplash-300h.webp"
                    loading="eager"
                    className="direito-de-famlia-image2 section_image"
                  />
                  <div className="direito-de-famlia-container22">
                    <span className="direito-de-famlia-text23">
                      Ações Sobre Guarda de Menores
                    </span>
                    <span className="direito-de-famlia-text24">
                      <span>
                        {' '}
                        A interação entre pais e filhos é crucial para o
                        desenvolvimento saudável das crianças. Quando não vivem
                        juntos, é importante garantir visitas regulares do
                        genitor não guardião para manter esse vínculo. As
                        visitas são períodos de interação entre pais e filhos,
                        facilitando essa conexão mesmo em lares separados.
                      </span>
                      <br></br>
                    </span>
                  </div>
                </div>
                <div className="direito-de-famlia-container23">
                  <img
                    alt="image"
                    src="/padre%20reglas%20nino%20(optimized)-300h.webp"
                    loading="eager"
                    className="direito-de-famlia-image3 section_image"
                  />
                  <div className="direito-de-famlia-container24">
                    <span className="direito-de-famlia-text27">
                      Ações de Regulamentação de Visitas
                    </span>
                    <span className="direito-de-famlia-text28">
                      <span>
                        {' '}
                        É cada vez mais comum pais separados, solteiros ou
                        recasados. A guarda compartilhada, onde ambos os pais
                        dividem responsabilidades na criação dos filhos, vem
                        ganhando destaque. As decisões sobre os filhos são
                        tomadas em consenso, visando o bem-estar deles. Não
                        implica necessariamente divisão equitativa do tempo, mas
                        ambos os pais mantêm convivência. Quando há disputa pela
                        guarda exclusiva, o Judiciário decide com base no melhor
                        interesse das crianças, garantindo uma decisão justa e
                        equitativa.
                      </span>
                      <br></br>
                    </span>
                  </div>
                </div>
                <div className="direito-de-famlia-container25">
                  <img
                    alt="image"
                    src="/coin%20stack%20white%20background%20(optimized)-300h.webp"
                    loading="eager"
                    className="direito-de-famlia-image4 section_image"
                  />
                  <div className="direito-de-famlia-container26">
                    <span className="direito-de-famlia-text31">
                      Ações sobre Pensão Alimentícia
                    </span>
                    <span className="direito-de-famlia-text32">
                      <span>
                        {' '}
                        O direito à pensão alimentícia geralmente surge da
                        incapacidade de uma pessoa de sustentar a si mesma, seja
                        por ser menor de idade, idosa, ou inválida, e tem a
                        possibilidade de recorrer a um indivíduo com o qual
                        mantém laço, seja consanguíneo ou matrimonial. O dever
                        de prover alimentos é estabelecido por lei, e aquele que
                        for considerado devedor é obrigado a cumprir essa
                        obrigação, sujeito até mesmo a medidas coercitivas como
                        a prisão.
                      </span>
                      <br></br>
                    </span>
                    <span className="direito-de-famlia-text35">
                      Valor da Pensão
                    </span>
                    <span className="direito-de-famlia-text36">
                      O princípio fundamental considerado reside na avaliação da
                      extensão das necessidades da parte requerente e da
                      capacidade da parte fornecedora em prover pensão. Na
                      ausência de um acordo mútuo, o juiz invariavelmente
                      aplicará o princípio do binômio &apos;possibilidade versus
                      necessidade&apos;.
                    </span>
                  </div>
                </div>
                <div className="direito-de-famlia-container27">
                  <span className="Head direito-de-famlia-text37">
                    Extrajudicial
                  </span>
                </div>
                <div className="direito-de-famlia-container28">
                  <div className="direito-de-famlia-container29">
                    <span className="direito-de-famlia-text38">
                      <span>Acompanhamento e Realização de Testamentos</span>
                      <br></br>
                    </span>
                    <span className="direito-de-famlia-text41">
                      O testamento é um instrumento crucial no Planejamento
                      Sucessório, permitindo que os bens sejam distribuídos de
                      acordo com a vontade expressa do titular do patrimônio.
                      Embora a lei preveja uma sucessão de bens em casos de
                      ausência de testamento, essa disposição nem sempre reflete
                      os desejos do falecido. Portanto, a elaboração de um
                      testamento é essencial para assegurar que os ativos sejam
                      distribuídos conforme a última vontade do
                      indivíduo.Existem diversas formas de proceder com um
                      testamento, sendo a mais comum a forma pública. Nosso
                      serviço abrange desde a orientação inicial até a redação
                      da minuta que melhor atenda aos interesses do cliente,
                      garantindo um processo eficiente e alinhado com seus
                      desejos. Além do testamento público, também são
                      considerados o testamento particular, codicilos e outros
                      atos jurídicos que viabilizam a concretização da última
                      vontade do testador.
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/familia-testamento.jpg"
                    loading="eager"
                    className="section_image"
                  />
                </div>
                <div className="direito-de-famlia-container30">
                  <div className="direito-de-famlia-container31">
                    <span className="direito-de-famlia-text42">
                      <span>Pacto Antenupcial</span>
                      <br></br>
                    </span>
                    <span className="direito-de-famlia-text45">
                      A escolha do regime matrimonial é essencial para os
                      noivos, permitindo que optem pelo modelo que melhor se
                      adeque às suas necessidades. É importante formalizar essa
                      decisão através de um pacto antenupcial antes do
                      casamento, para evitar a aplicação automática do regime da
                      comunhão parcial de bens. O pacto antenupcial oferece
                      flexibilidade aos cônjuges, permitindo a personalização
                      das disposições relativas ao regime de bens de acordo com
                      suas preferências.
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/familia-pacto-antenupcial.jpg"
                    loading="eager"
                    className="section_image"
                  />
                </div>
                <div className="direito-de-famlia-container32">
                  <div className="direito-de-famlia-container33">
                    <span className="direito-de-famlia-text46">
                      <span>Escritura e Contratos de União Estável</span>
                      <br></br>
                    </span>
                    <span className="direito-de-famlia-text49">
                      Com total discrição e profissionalismo, nossa equipe
                      redige minutas personalizadas em nosso escritório,
                      atendendo aos interesses específicos de cada cliente.
                      Essas minutas podem ser elaboradas para fins particulares
                      ou para formalização por meio de Escritura Pública. No
                      caso desta última modalidade, oferecemos um serviço
                      completo que inclui encaminhamento ao cartório e
                      acompanhamento integral do processo. Além disso,
                      proporcionamos a comodidade aos clientes de realizarem a
                      assinatura do documento diretamente em nosso escritório,
                      garantindo praticidade e segurança em todo o procedimento.
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/familia-uniao-estavel.jpg"
                    loading="eager"
                    className="section_image"
                  />
                </div>
                <div className="direito-de-famlia-container34">
                  <div className="direito-de-famlia-container35">
                    <span className="direito-de-famlia-text50">
                      <span>Reconhecimento de Paternidade</span>
                      <br></br>
                    </span>
                    <span className="direito-de-famlia-text53">
                      O reconhecimento da paternidade pode ser uma decisão
                      espontânea, dispensando a necessidade de ingressar com uma
                      ação de investigação de paternidade. Nesse contexto, a
                      vontade do progenitor pode ser formalizada por meio de
                      escritura pública ou documento particular a ser
                      devidamente arquivado no cartório competente. Em ambos os
                      casos, é fundamental que exista uma certeza inequívoca
                      quanto à manifestação da vontade do declarante.Ademais, é
                      importante ressaltar que o reconhecimento da filiação
                      também pode ser expresso por meio de testamento,
                      conferindo mais uma via legal para a efetivação desse
                      ato.É crucial entender que uma vez efetuado, o
                      reconhecimento da paternidade é irrevogável, acarretando
                      na averbação do nome do genitor no registro de nascimento
                      do filho, sem qualquer observação adicional.Essas medidas
                      visam assegurar a estabilidade e a segurança jurídica nas
                      relações familiares, promovendo o pleno reconhecimento do
                      vínculo paterno-filial de forma clara e definitiva.
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/familia-paternidade.jpg"
                    loading="eager"
                    className="section_image"
                  />
                </div>
                <div className="direito-de-famlia-container36">
                  <div className="direito-de-famlia-container37">
                    <span className="direito-de-famlia-text54">
                      Divórcios em Tabelionato
                    </span>
                    <span className="direito-de-famlia-text55">
                      Oferecemos serviços de redação de minutas personalizadas
                      de acordo com as necessidades e interesses específicos de
                      nossos clientes. Nossa equipe se encarrega de encaminhar
                      toda a documentação necessária ao cartório e acompanha de
                      perto todo o processo. Além disso, proporcionamos a
                      conveniência de assinar qualquer escritura de forma
                      discreta e segura em nosso escritório.É importante
                      ressaltar que o divórcio em Tabelionato é uma opção viável
                      para casais que não possuem filhos menores incapazes e que
                      tenham chegado a um acordo mútuo. Nossa equipe está
                      preparada para orientar e auxiliar durante todo o
                      processo, garantindo uma resolução eficiente e
                      satisfatória para ambas as partes.
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/familia-divorcio.jpg"
                    loading="eager"
                    className="section_image"
                  />
                </div>
                <div className="direito-de-famlia-container38">
                  <div className="direito-de-famlia-container39">
                    <span className="direito-de-famlia-text56">
                      Inventário e Partilha em Tabelionato
                    </span>
                    <span className="direito-de-famlia-text57">
                      O inventário pode ser conduzido em um tabelionato desde
                      que não haja testamento envolvido e a participação de
                      menores ou incapazes. Nessas situações específicas, a
                      intervenção judicial se torna necessária. Nosso escritório
                      oferece orientação, redação e acompanhamento em
                      inventários e partilhas, inclusive quando são conduzidos
                      em tabelionato. Com nossa expertise jurídica, garantimos
                      um processo eficiente e tranquilo, cuidando de todos os
                      aspectos legais envolvidos.
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/familia-inventario.jpg"
                    loading="eager"
                    className="section_image"
                  />
                </div>
              </div>
            </div>
          </div>
          <Footer rootClassName="footerroot-class-name11"></Footer>
          <Whatsapp></Whatsapp>
        </main>
      </div>
    </div>
  )
}

export default DireitoDeFamlia
